import React from 'react'
import PropTypes from 'prop-types'

import QuestionMultipleChoices from './QuestionMultipleChoices'
import QuestionOpenAnswer from './QuestionOpenAnswer'
import QuestionTrueOrFalse from './QuestionTrueOrFalse'

const QuestionForm = (question) => {

    const questionComponentType = {
        1: QuestionMultipleChoices, //ONE_ANSWER
        2: QuestionTrueOrFalse, //TRUE OR FALSE
        3: QuestionOpenAnswer, //OPEN_ANSWER
    }
    
    const currentQuestion = question   
    const QuestionElement = questionComponentType[currentQuestion.type]

    return(
        <QuestionElement {...currentQuestion} />
    )

}

export default QuestionForm


QuestionForm.propTypes = {
    question: PropTypes.object,
    answer: PropTypes.object,  
}

QuestionForm.defaultProps = {}




// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questions/QuestionForm.js